import React, { InputHTMLAttributes, useEffect, useRef, useState } from "react";
import { Field } from "formik";
import clsx from "clsx";

import "./Input.scss";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  chartsCount?: number;
  label: string;
  maxLength?: number;
  type?: string;
  inputId: string;
  invalid?: boolean;
  formik?: boolean;
  className?: string;
  labelClassName?: string;
  chartCounterClassName?: string;
  containerClassName?: string;
  errorId?: string;
  error?: string;
  errorClassName?: string;
  labelHeader?: boolean;
  textareaNative?: boolean;
  component?: string;
  rows?: number;
  onChange(data: any): void;
}

const Input: React.FC<Props> = ({
  formik = false,
  labelHeader = false,
  chartsCount,
  chartCounterClassName,
  containerClassName,
  errorId,
  error,
  errorClassName,
  inputId,
  className,
  invalid,
  label,
  labelClassName,
  maxLength,
  textareaNative,
  type,
  onChange,
  ...props
}) => {
  const errorRef = useRef<HTMLParagraphElement>(null);
  const [isEmptyError, setIsEmptyError] = useState(true);

  useEffect(() => {
    if (errorRef?.current) {
      setIsEmptyError(errorRef?.current?.clientHeight === 0)
    }
  }, [errorRef?.current?.clientHeight]);
  
  const containerClassNameClsx = clsx([
    "input-container",
    containerClassName,
  ]);
  const classNameClsx = clsx([
    "input",
    invalid && "input--invalid",
    className,
  ]);
  const labelClassNameClsx = clsx([
    "input__label",
    labelHeader && "input__label--header",
    labelClassName,
  ]);
  const chartCounterClassNameClsx = clsx([
    "input__charts-counter",
    chartCounterClassName,
  ]);
  const errorClassNameClsx = clsx([
    "input__error",
    maxLength && "input__error--top",
    errorClassName,
  ]);
  const Tag = formik ? Field : textareaNative ? "textarea" : "input";

  return (
    <div className={containerClassNameClsx}>
      <label htmlFor={inputId} className={labelClassNameClsx}>
        {label}
      </label>
      <Tag
        aria-describedby={!isEmptyError ? errorId : null}
        aria-label={
          chartsCount && maxLength
            ? `${label}, maksymalna liczba znaków: ${maxLength}. Wpisano ${chartsCount} znaków.`
            : undefined
        }
        className={classNameClsx}
        id={inputId}
        maxLength={maxLength}
        onChange={onChange}
        {...props}
      />
      {maxLength && (
        <>
          <p className={chartCounterClassNameClsx}>
            {chartsCount}/{maxLength}
          </p>
          {chartsCount === maxLength && (
            <p className='sr-only' aria-live='assertive' role='alert'>
              Wpisano maksymalną liczbę znaków.
            </p>
          )}
        </>
      )}
      {errorId && (
        <p ref={errorRef} id={errorId} className={errorClassNameClsx} role='alert'>
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;
